import React from "react";

export default function Solution() {
  return (
    <>
      <div className="anchor" id="solution" aria-hidden="true"></div>
      <section className="solution" aria-labelledby="solution-heading">
        <div className="auto__container">
          <div className="solution__inner">
            <div className="solution__inner-title">
              <h2 id="solution-heading">The Proxium Product Line</h2>
              <p>
                Introducing Proxidil and Femixidil:
                <span>Tailored Solutions for Hair Restoration.</span>
              </p>
            </div>
            <div className="solution__inner-row">
              <div className="solutionItem" role="article">
                <h3>Masculine</h3>
                <div className="solutionItem__image">
                  <img src="/images/solution/man.png" alt="Proxidil - Masculine hair restoration solution" />
                </div>
              </div>
              <div className="solutionItem" role="article">
                <h3>Feminine</h3>
                <div className="solutionItem__image">
                  <img src="/images/solution/woman.png" alt="Femixidil - Feminine hair restoration solution" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
